import {combineReducers} from "redux";

import ajouterDemandeVideoReducer from "./ajouterDemandeVideo";

export default combineReducers({
    ajouterDemandeVideo: ajouterDemandeVideoReducer
});